import type { StepProgressStatus } from 'settle-ui/components/StepProgress/StepProgress'
import { getLabelByStep } from '../getLabelByStep/getLabelByStep'
import type { StepEnum } from 'gql/types'

interface GetOnboardingStepsOptions {
  orderedSteps: StepEnum[]
  currentStep: StepEnum | null
}

interface GetStatusOptions {
  index: number
  currentIndex: number
}

const getStatus = ({ index, currentIndex }: GetStatusOptions): StepProgressStatus => {
  if (index === currentIndex) {
    return 'current'
  }
  return index < currentIndex ? 'complete' : 'incomplete'
}

export const getOnboardingSteps = ({ orderedSteps, currentStep }: GetOnboardingStepsOptions) => {
  const currentIndex = currentStep ? orderedSteps.indexOf(currentStep) : orderedSteps.length

  return orderedSteps.map((step, index) => ({
    id: step,
    label: getLabelByStep(step),
    status: getStatus({ index, currentIndex }),
  }))
}
